import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Donut } from '@netbasequid/chart'
import { useDisplayTheme } from '../../../hooks/useUiState'
import { useDashboardWidgetData } from '../../../hooks/useWidgetState'
import PlaceHolder from '../../share/PlaceHolder'
import WaveLoading from '../../share/WaveLoading'

const MetricGridContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  height: inherit;
`
const MetricGridItemContainer = styled.div`
  flex: 1;
`

const MetricGridWidget = ({ widgetId }) => {
  const theme = useDisplayTheme()
  const widgetData = useDashboardWidgetData(widgetId)

  if (!widgetData) return <PlaceHolder />
  if (widgetData.status === 'loading') return <WaveLoading />
  if (widgetData.status === 'failed') return <>fail</>
  const mentions = [
    { name: 'Neurals', y: 216211, color: theme === 'dark' ? '#BFC1C6' : '#9397A0' },
    { name: 'Positives', y: 29456, color: theme === 'dark' ? '#45C65A' : '#3BA755' },
    { name: 'Negatives', y: 16628, color: theme === 'dark' ? '#FE8F7D' : '#FE5C4C' }
  ]
  const posts = [
    { name: 'Videos', y: 20148 },
    { name: 'Images', y: 41753 },
    { name: 'Others', y: 181675 }
  ]
  const sentiments = [
    { name: 'Positives', y: 29456, color: theme === 'dark' ? '#45C65A' : '#3BA755' },
    { name: 'Negatives', y: 16628, color: theme === 'dark' ? '#FE8F7D' : '#FE5C4C' }
  ]
  const impressions = [
    { name: 'Exposure', y: 8360000000, color: theme === 'dark' ? '#BFC1C6' : '#9397A0' }
  ]

  return (
    <MetricGridContainer>
      <MetricGridItemContainer>
        <Donut
          data={mentions}
          chartTitle="Mentions"
          mode={theme}
          showLegend
          legendPosition="bottom"
        />
      </MetricGridItemContainer>
      <MetricGridItemContainer>
        <Donut data={posts} chartTitle="Post" mode={theme} showLegend legendPosition="bottom" />
      </MetricGridItemContainer>
      <MetricGridItemContainer>
        <Donut
          data={sentiments}
          chartTitle="Net Sentiment"
          mode={theme}
          showLegend
          legendPosition="bottom"
        />{' '}
      </MetricGridItemContainer>
      <MetricGridItemContainer>
        <Donut
          data={impressions}
          chartTitle="Impressions"
          mode={theme}
          showLegend
          legendPosition="bottom"
        />{' '}
      </MetricGridItemContainer>
    </MetricGridContainer>
  )
}

MetricGridWidget.propTypes = {
  widgetId: PropTypes.number.isRequired
}

export default MetricGridWidget
